// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__6XqtT","small":"table_small__3x6HH"};